module.exports = new __parcel__URL__("testimoni-neo-mobile.63e4b5d3.webp").toString();